module.exports = __webpack_public_path__ + "static/media/Organize_A_Trip_mr.239363af.jpg";